import ReportStatusChip from '@/features/report-list/ReportStatusChip';
import type { ReportListStatus } from '@/models/report';
import { formatDateTime } from '../../utils/formatDateTime';
import styles from './ReportHeader.module.css';

interface ReportHeaderProps {
  status: string | null;
  reportType?: string;
  createdAt?: string;
  accession?: string;
  facility?: string;
}

export default function ReportHeader({
  status,
  reportType = 'Echo',
  createdAt,
  accession,
  facility,
}: ReportHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <h2 className={styles.title}>Echo Report</h2>
        {status && <ReportStatusChip status={status as ReportListStatus} />}
      </div>
      <div className={styles.meta}>
        {reportType && <span>{reportType}</span>}
        {createdAt && (
          <>
            <span className={styles.separator}>·</span>
            <span>{formatDateTime(createdAt)}</span>
          </>
        )}
        {accession && (
          <>
            <span className={styles.separator}>·</span>
            <span>{accession}</span>
          </>
        )}
        {facility && (
          <>
            <span className={styles.separator}>·</span>
            <span>{facility}</span>
          </>
        )}
      </div>
    </div>
  );
}
